<template>
  <div>
    <p class="cm-mg-p-wzd">1.1 {{ $t('fertilization.fertilizer_info') }}</p>
    <hr />
    <br />
    <div class="row">
      <div class="col-6">
        <div class="form-group has-label">
          <label class="text-transform-none"
            >{{ $t('common_words.select_a_company') }} *</label
          >
          <br />
          <el-select
            clearable
            class="select-primary custom-width-select fer-rels shadow-sm"
            size="large"
            v-model="model.business_id"
            :placeholder="`${$t('common_words.select')}...`"
            filterable
          >
            <el-option
              v-for="option in businesses"
              class="select-primary"
              :value="option.id"
              :label="option.name"
              :key="option.name"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-6">
        <fg-input
          ref="code"
          type="text"
          :label="`${$t('common_words.code')} *`"
          v-model="model.code"
          v-validate="modelValidations.code"
          name="fertilization.fertilizer_code"
          :error="getError('fertilization.fertilizer_code', true)"
        >
        </fg-input>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <fg-input
          ref="name"
          type="text"
          :label="`${$t('common_words.name')} *`"
          v-model="model.name"
          v-validate="modelValidations.name"
          name="fertilization.fertilizer_name"
          :error="getError('fertilization.fertilizer_name', true)"
        >
        </fg-input>
      </div>
      <div class="col-6">
        <div class="form-group has-label">
          <label class="text-transform-none"
            >{{ $t('labor.unit_of_measure') }} *</label
          >
          <br />
          <el-select
            clearable
            class="select-primary custom-width-select unit-rels shadow-sm"
            size="large"
            v-model="model.unit_measure"
            :placeholder="`${$t('common_words.select')}...`"
            filterable
          >
            <el-option
              v-for="option in units"
              class="select-primary"
              :value="option.symbol"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <fg-input
          ref="value"
          type="number"
          :label="$t('common_words.value')"
          v-model="model.value"
          name="valor"
          min="0"
        >
        </fg-input>
      </div>
      <div class="col-6">
        <fg-input
          ref="conversion_factor"
          type="number"
          :label="`${$t('common_words.conversion_factor')}: *`"
          v-model="model.conversion_factor"
          v-validate="modelValidations.conversion_factor"
          name="common_words.conversion_factor_lowercase"
          step="0.01"
          min="0"
          :error="getError('common_words.conversion_factor_lowercase', true)"
        >
        </fg-input>
      </div>
    </div>
    <div class="row" v-show="errorAlert">
      <div class="col-lg-12">
        <br />
        <el-alert
          ref="error_alert"
          :title="$t('common_words.errors')"
          type="error"
          >{{ error }}</el-alert
        >
      </div>
    </div>
  </div>
</template>
<script>
import mixinMasters from 'src/util/mixinMasters';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinPermissions from 'src/util/mixinPermissions';
import { Axios } from 'src/class/Axios.js';

export default {
  data() {
    return {
      model: {
        code: null,
        name: null,
        unit_measure: null,
        value: null,
        conversion_factor: null,
        business_id: null,
      },
      modelValidations: {
        code: {
          required: true,
        },

        name: {
          required: true,
        },

        unit_measure: {
          required: true,
        },

        conversion_factor: {
          required: true,
        },
      },
      businesses: null,
      units: null,
    };
  },

  mixins: [mixinMasters, MixinForm, MixinPermissions],

  methods: {
    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          this.$emit('on-validated', res, this.model);
          let others = [];
          this.$emit('fillFertilizerForm', 'firstStep', {
            names_business: others,
          });
          return res;
        })
        .then((resp) => {
          if (!resp) return resp;

          if (this.model.business_id == null) {
            this.highlightItem('fer-rels');
            return false;
          } else if (this.model.unit_measure == null) {
            this.highlightItem('unit-rels');
            return false;
          } else {
            return true;
          }
        });
    },
  },

  created() {
    this.showHideLoading(true);
    if (this.isCreate() || this.isUpdate()) {
      Axios.getMasters('businesses/only')
        .then((response) => {
          this.businesses = response.data.data;
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));

      Axios.getMasters('units/fertilizer')
        .then((response) => {
          this.units = response.data.data;
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.showHideLoading(true);

    let editForm = {};

    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));

      this.model.id = editForm.id;
      this.model.code = editForm.code;
      this.model.name = editForm.name;
      this.model.unit_measure = editForm.unit_measure;
      this.model.value = editForm.value;
      this.model.conversion_factor = editForm.conversion_factor;
      this.model.business_id = editForm.business_id;
      this.model.user_id = editForm.user_id;

      this.showHideLoading();
    }
  },
};
</script>
